export const HOME_RECORDS_COUNT_LOAD = 'HOME_RECORDS_COUNT_LOAD'
export const loadRecordsCount = (
  accountId: string,
  projectId: string,
  moduleName: string,
  period: string,
  filterState: any
) => {
  return {
    type: HOME_RECORDS_COUNT_LOAD,
    accountId,
    projectId,
    moduleName,
    period,
    filterState
  }
}

export const HOME_RECORDS_COUNT_LOAD_SUCCESS = 'HOME_RECORDS_COUNT_LOAD_SUCCESS'
export const loadRecordsCountSuccess = (moduleName, period, recordsCount) => {
  return {
    type: HOME_RECORDS_COUNT_LOAD_SUCCESS,
    moduleName,
    period,
    recordsCount
  }
}

export const HOME_RECORDS_COUNT_LOAD_FAILURE = 'HOME_RECORDS_COUNT_LOAD_FAILURE'
export const loadRecordsCountFailure = (moduleName, period, error) => {
  return {
    type: HOME_RECORDS_COUNT_LOAD_FAILURE,
    moduleName,
    period,
    error
  }
}

type PeriodType = 'total' | 'today' | 'last30Days' | 'assignedToMe'

export interface LoadRecordsCountAction {
  type: typeof HOME_RECORDS_COUNT_LOAD
  accountId: string
  projectId: string
  moduleName: string
  period: PeriodType
  filterState: any
}
